export default "__VITE_ASSET__BDN_iuqQ__"